import { useState } from 'react';

import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { useSearchParams } from 'react-router-dom';

import Books from './Books';
import Products from './Products';
import CollaborationPage from '../../containers/CollaborationPage';
import Box from '../../components/layout/Box';

const Search = () => {
  const [activeTab, setActiveTab] = useState('products');
  const [sp] = useSearchParams();
  const searchString = sp.get('q');

  return (
    <CollaborationPage className="py-3">
      <h2>Sökresultat för &quot;{searchString}&quot;</h2>

      <Tabs
        id="controlled-tab-example"
        activeKey={activeTab}
        onSelect={(key) => setActiveTab(key)}
        className="mb-3 mt-2"
      >
        <Tab eventKey="products" title="Artiklar">
          <Box className="mt-3">
            <Products searchString={searchString} />
          </Box>
        </Tab>
        <Tab eventKey="books" title="Annonser">
          <Box
            borderWidth={0}
            className="mt-3"
            backgroundColor="transparentColor"
          >
            <Books searchString={searchString} />
          </Box>
        </Tab>
      </Tabs>
    </CollaborationPage>
  );
};

export default Search;
